var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bookingdashboard"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    class: {
      'buttonselected': _vm.buttonselected === 'day'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getFilterData('day')
      }
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    class: {
      'buttonselected': _vm.buttonselected === 'week'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getFilterData('week')
      }
    }
  }, [_vm._v("Week")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ",
    class: {
      'buttonselected': _vm.buttonselected === 'month'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getFilterData('month')
      }
    }
  }, [_vm._v("Month")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.fromdate) + " to " + _vm._s(_vm.todate) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.barchart
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.barchart2
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.totalchart
    }
  })], 1)]), _vm._v(" "), (_vm.isDummyHub) ? _c('div', [_c('b-input-group', {
    staticClass: "image-upload"
  }, [_c('label', {
    attrs: {
      "for": "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "cursor": "pointer"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event)
      }
    }
  })]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": ".jpeg,.jpg,.png",
      "multiple": "multiple",
      "id": "files",
      "name": "Image"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event)
      }
    }
  })])], 1) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3e94348","hasScoped":true}!./src/modules/cargobooking/views/booking/bookingdashboard/bookingdashboard.component.html
// module id = 1284
// module chunks = 3